const ExamStatusEnum = {
	PLANNED: 4,
	STARTED: 8,
	REPORT: 16,
	TRANSCRIPTION: 24,
	TO_SIGN: 32,
	SIGNED: 64,
};

export default ExamStatusEnum;
